import { Instance } from 'mobx-state-tree';
import { RouteConstraintEndLocationDtoModelBase } from './RouteConstraintEndLocationDtoModel.base';

/* The TypeScript type of an instance of RouteConstraintEndLocationDtoModel */
export interface RouteConstraintEndLocationDtoModelType extends Instance<typeof RouteConstraintEndLocationDtoModel.Type> {}

/* A graphql query fragment builders for RouteConstraintEndLocationDtoModel */
export { selectFromRouteConstraintEndLocationDto, routeConstraintEndLocationDtoModelPrimitives, RouteConstraintEndLocationDtoModelSelector } from './RouteConstraintEndLocationDtoModel.base';

/**
 * RouteConstraintEndLocationDtoModel
 */
export const RouteConstraintEndLocationDtoModel = RouteConstraintEndLocationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
